import { useEffect } from 'react';

export default function SEO() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://rebornbarbershop.com.au';

    // Local Business Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "HairSalon",
      "name": "Reborn Barbershop",
      "image": "https://static.readdy.ai/image/559167c3f2f3505c4b7c1eaccde744d9/54c40221c067c562571a6d30c158173b.jpeg",
      "description": "Premium barbershop in Heidelberg Heights offering professional haircuts, skin fades, taper fades, and beard grooming services.",
      "@id": siteUrl,
      "url": siteUrl,
      "telephone": "0451279664",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "27 Southern Rd",
        "addressLocality": "Heidelberg Heights",
        "addressRegion": "VIC",
        "postalCode": "3081",
        "addressCountry": "AU"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": -37.7456,
        "longitude": 145.0567
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Monday",
          "opens": "10:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Tuesday",
          "opens": "10:00",
          "closes": "19:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Wednesday",
          "opens": "10:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Thursday",
          "opens": "10:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Friday",
          "opens": "10:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "17:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Sunday",
          "opens": "10:00",
          "closes": "16:00"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/rebornbarbershop",
        "https://www.instagram.com/rebornbarbershop"
      ]
    };

    // Services Schema
    const servicesSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "Service",
          "name": "Skin Fade",
          "description": "Precision clipper work creating seamless transitions from skin to hair"
        },
        {
          "@type": "Service",
          "name": "Taper Fade",
          "description": "Expert blending technique for a gradual fade"
        },
        {
          "@type": "Service",
          "name": "Buzz Cut",
          "description": "Clean, uniform length with precise edging"
        },
        {
          "@type": "Service",
          "name": "Classic Haircut",
          "description": "Timeless scissor cuts tailored to your style"
        },
        {
          "@type": "Service",
          "name": "Beard Trim",
          "description": "Expert beard shaping and trimming"
        },
        {
          "@type": "Service",
          "name": "Beard Line Up",
          "description": "Sharp, precise beard edging"
        },
        {
          "@type": "Service",
          "name": "Haircut & Beard Combo",
          "description": "Complete grooming package"
        }
      ]
    };

    // Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Reborn Barbershop",
      "url": siteUrl
    };

    // Create and inject script tags
    const schemas = [localBusinessSchema, servicesSchema, websiteSchema];
    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    // Cleanup function
    return () => {
      scriptElements.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
}